import { InfoCircle } from 'assets/icons/InfoCircle';

import './styles.scss';
import { useTranslation } from 'react-i18next';

export const DisclaimerCard = () => {
  const { t } = useTranslation();
  return (
    <div className="disclaimer-card">
      <div className="card-header">
        <InfoCircle />
        <p className="label">{t('reminder_title')}</p>
      </div>
      <div className="card-content">
        <p>{t('reminder_content')}</p>
        <br />
        <p>
          <p className="label">{t('note_title')}</p>
          <p>{t('reminder_note')}</p>
        </p>
      </div>
    </div>
  );
};
